import {AbstractControl, ValidatorFn} from '@angular/forms';

/**
 * The allowed mime types for the file upload.
 */
export const ALLOWED_MIME_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'image/jpeg'
];

/**
 * The maximum file size allowed. (kb)
 */
export const MAX_FILE_SIZE = 104857600 // 100MB;

/**
 * A validator function to check if the file is a valid mime type.
 * @param allowedTypes
 */
export function documentMimeTypeValidator(allowedTypes: string[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const fileControl = control.value;
    if (fileControl) {
      const file = fileControl.file as File;
      const mimeType = file.type;
      if (allowedTypes.every(type => mimeType !== type)) {
        return { invalidMimeType: true };
      }
    }
    return null;
  };
}

/**
 * A validator function to check if the file is a valid size.
 * @param maxSize
 */
export function documentMaxSizeValidator(maxSize: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const fileControl = control.value;
    if (fileControl) {
      const file = fileControl.file as File;
      const fileSize = file.size;
      if (fileSize > maxSize) {
        return { invalidFileSize: true };
      }
    }
    return null;
  };
}
